// @flow
import styled from 'styled-components';

const SpinnerWrapper = styled.div`
    position: relative;
    transition: transform 0.3s ease-in;
`;

const small = 'scale(0.8)';
const medium = 'scale(0.92)';

export const SpinnerWrapperTop = styled(SpinnerWrapper)`
    transform: ${({ mouseOver, heatHovered, isUpdating }) =>
        isUpdating ? `${medium}` : mouseOver ? 'scale(1)' : heatHovered ? `${small}` : `${medium}`};
`;

export const SpinnerWrapperBottom = styled(SpinnerWrapper)`
    transform: ${({ mouseOver, coolHovered, isUpdating }) =>
        isUpdating ? `${medium}` : mouseOver ? 'scale(1)' : coolHovered ? `${small}` : `${medium}`};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/dual-spinner/styles.js